'use strict';

(function (angular) {
    'use strict';

    angular.module('zp.nav').controller('sitemapController', sitemapController);

    /** @ngInject */
    function sitemapController($q, $state, vendorsService, SlugerService) {

        var vm = this;

        vm.vendorCategories = [];
        vm.vendors = [];

        vm.getProfileUrl = getProfileUrl;

        (function activate() {
            loadVendorCategories().then(loadVendors).then(function () {
                console.log(vm.vendors);
            });
        })();

        function loadVendorCategories() {
            return vendorsService.getAll().then(function (res) {
                vm.vendorCategories = res.map(function (v) {
                    return v.name;
                });
            });
        }

        function loadVendors() {
            var promises = [];
            for (var i = 0; i < vm.vendorCategories.length; i++) {
                promises.push(loadVendorsForCategory(vm.vendorCategories[i]));
            }
            return $q.all(promises);
        }

        function loadVendorsForCategory(category) {
            return vendorsService.getVendors(category).then(function (res) {
                for (var i = 0; i < res.length; i++) {
                    vm.vendors.push(res[i]);
                }
            });
        }

        function getProfileUrl(vendor) {
            console.log(vendor);
            return $state.href('nav.vendor-slug', { vendor: vendor.category, slugCity: SlugerService.generateSlug(vendor.city), slugName: SlugerService.generateSlug(vendor.name) });
        }
    }
})(window.angular);